module.exports = __webpack_public_path__ + "static/img/newFood2.9a67654.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newFood2.png
// module id = AfTq
// module chunks = 2